export const SET_DIALOG = "SET_DIALOG";

const initialState = {
  open: false,
  maxWidth: "",
  title: "",
  scroll: "",
  data: <></>,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DIALOG:
      const { open, maxWidth, title, data, scroll } = action;
      return {
        ...state,
        open,
        maxWidth,
        title,
        scroll,
        data,
      };
    default:
      return state;
  }
};

export const setDialog = (open, maxWidth, title, data, scroll) => ({
  type: SET_DIALOG,
  open,
  maxWidth,
  title,
  scroll,
  data,
});
